import { cn } from '@/lib/utils'

interface PageHeaderProps {
  title: string
  description?: string
  children?: React.ReactNode
  className?: string
}

export function PageHeader({ title, description, children, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-1 pb-6 sm:flex-row sm:items-start sm:justify-between', className)}>
      <div className="min-w-0">
        {/* F02: Seiten-h1 26px / Gewicht 650 (--fm-h1). */}
        <h1 className="text-[26px] font-[650] leading-tight tracking-tight text-foreground">{title}</h1>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {children && <div className="flex shrink-0 items-center gap-2 pt-2 sm:pt-0">{children}</div>}
    </div>
  )
}
